module.exports = __webpack_public_path__ + "static/websites1-e6b8bc5b72d27e72c748555dfa08546f.jpg";